import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/search',
    name: 'search',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/SearchView.vue')
  },
  {
    path: '/comparison',
    name: 'comparison',
    component: () =>
      import(/* webpackChunkName: "comparison" */ '../views/ComparisonView.vue')
  },
  {
    path: '/publications/:id',
    name: 'publication',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/PropertyView.vue')
  },
  {
    path: '/blog',
    name: 'blog',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/BlogView.vue')
  },
  {
    path: '/blog/:id',
    name: 'article',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ArticleView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ContactView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () =>
      import(/* webpackChunkName: "register" */ '../views/RegisterView.vue')
  },
  {
    path: '/account/favorites',
    name: 'favorites',
    component: () =>
      import(/* webpackChunkName: "favorites" */ '../views/accounts/FavoritesView.vue'),
    meta: {
      requiresAuth: true,
      allowedRoles: ['cliente']
    },
  },
  {
    path: '/account/profile',
    name: 'profile',
    component: () =>
      import(/* webpackChunkName: "profile" */ '../views/accounts/ProfileView.vue'),
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/account/mi-rent',
    name: 'my-rent',
    component: () =>
      import(/* webpackChunkName: "my-rent" */ '../views/accounts/MyRentView.vue'),
    meta: {
      requiresAuth: true,
      allowedRoles: ['cliente']
    },
  },
  // Admin Routes
  {
    path: '/admin',
    name: 'admin-dashboard',
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/AdminDashboard.vue'),
    meta: {
      requiresAuth: true,
      requiredRole: ['Super Admin', 'Admin Inmobiliaria']
    }
  },
  {
    path: '/admin/agentes',
    name: 'admin-agentes',
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/AgenteManagement.vue'),
    meta: {
      requiresAuth: true,
      requiredRole: ['Super Admin', 'Admin Inmobiliaria']
    }
  },
  {
    path: '/admin/inmobiliarias',
    name: 'admin-inmobiliarias',
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/InmobiliariaManagement.vue'),
    meta: {
      requiresAuth: true,
      requiredRole: ['Super Admin']
    }
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () =>
      import(/* webpackChunkName: "error" */ '../views/UnauthorizedView.vue')
  },
  {
    path: '*',
    name: '404',
    component: () =>
      import(/* webpackChunkName: "404" */ '../views/NotFoundView.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const userRole = store.getters['auth/getRol'];

  // Chequear si la ruta requiere autenticación
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ name: 'login' });
      return;
    }

    // Chequear si la ruta requiere un rol específico
    if (to.matched.some(record => record.meta.requiredRole)) {
      const requiredRoles = to.matched.find(record => record.meta.requiredRole)?.meta.requiredRole;
      if (requiredRoles && !requiredRoles.includes(userRole)) {
        next({ name: 'unauthorized' });
        return;
      }
    }

    next();
  } else {
    next();
  }
});

export default router;
